<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ isView ? "View " : $route.params.id ? "Edit " : "Add " }} Student
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <fieldset :disabled="isView">
      <form @submit.prevent="saveStudent">
        <!-- Details -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0"><h3>Details</h3></div>
              <div class="card-body">
                <div
                  class="form-row"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  <div class="form-group col-md-6">
                    <label>School<span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="schoolId"
                      required
                      @change="onChangeSchool"
                    >
                      <option value>-- Please Select School --</option>
                      <option
                        v-for="item in schools"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>User Type<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="userType"
                      class="form-control"
                      placeholder="Input User Type Here"
                      maxlength="50"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      Registration Date<span class="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      v-model="registrationDate"
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6 id-div">
                    <label>ID<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="username"
                      class="form-control"
                      placeholder="Input ID Here"
                      maxlength="50"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label style="line-height: 15px">
                      Password
                      <span class="note">
                        (must be minimum of 6 characters with combination of
                        upper and lower case letters, numbers, and
                        non-alphanumeric symbols)
                      </span>
                    </label>
                    <input
                      type="text"
                      v-model="password"
                      class="form-control"
                      placeholder="Password"
                      maxlength="50"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Name<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="name"
                      class="form-control"
                      placeholder="Input Name Here"
                      maxlength="100"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      v-model="dateOfBirth"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Gender</label>
                    <div class="form-row">
                      <div :class="showGenderCustom ? 'col-5' : 'col-12'">
                        <select
                          class="form-control"
                          v-model="genderId"
                          @change="onChangeGender($event)"
                        >
                          <option value>-- Please Select Gender --</option>
                          <option
                            v-for="item in genders"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-7" v-if="showGenderCustom">
                        <input
                          type="text"
                          v-model="genderCustom"
                          class="form-control"
                          placeholder="Input Custom Gender Here"
                          maxlength="50"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Nationality</label>
                    <select class="form-control" v-model="nationalityId">
                      <option value>-- Please Select Nationality --</option>
                      <option
                        v-for="item in nationalities"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Citizenship</label>
                    <div class="form-row">
                      <div :class="showCitizenshipOther ? 'col-5' : 'col-12'">
                        <select
                          class="form-control"
                          v-model="citizenshipOtherNationalityId"
                          @change="onChangeCitizenship($event)"
                        >
                          <option value>-- Please Select Citizenship --</option>
                          <option
                            v-for="item in nationalities"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-7" v-if="showCitizenshipOther">
                        <select
                          class="form-control"
                          v-model="citizenshipOtherNationalityId"
                          required
                        >
                          <option value>-- Please Select Nationality --</option>
                          <option
                            v-for="item in nationalities"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Document Number</label>
                    <input
                      type="text"
                      v-model="documentNumber"
                      class="form-control"
                      placeholder="Input Document Number Here"
                      maxlength="50"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Details -->

        <!-- Contact Information -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Contact Information</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Email<span class="text-danger">*</span></label>
                    <div class="table-responsive">
                      <table class="table table-bordered email-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="email-col">Email</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addEmail"
                              >
                                <i class="fa fa-plus" title="Add Email"></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(email, i) in emails" :key="i">
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="email.EmailTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeEmailType($event, i)"
                              >
                                <option
                                  v-for="item in emailTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="email.EmailTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="email.ShowEmailTypeOther"
                              />
                            </td>
                            <td class="email-col">
                              <input
                                type="email"
                                v-model="email.Email"
                                class="form-control form-control-sm"
                                placeholder="Email"
                                required
                                maxlength="100"
                              />
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeEmail(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Email"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      Contact Number<span class="text-danger">*</span>
                    </label>
                    <div class="table-responsive">
                      <table class="table table-bordered contact-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="phone-col">Phone</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addContactNumber"
                              >
                                <i class="fa fa-plus" title="Add Phone"></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(contactNumber, i) in contactNumbers"
                            :key="i"
                          >
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="contactNumber.ContactNumberTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeContactNumberType($event, i)"
                              >
                                <option
                                  v-for="item in contactNumberTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="contactNumber.ContactNumberTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="contactNumber.ShowContactNumberTypeOther"
                              />
                            </td>
                            <td class="phone-col">
                              <input
                                type="text"
                                v-model="contactNumber.Phone"
                                class="form-control form-control-sm"
                                placeholder="Phone"
                                maxlength="20"
                              />
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeContactNumber(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Phone"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Address</label>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="street-col">Street 1</th>
                            <th class="street-col">Street 2</th>
                            <th class="city-col">City</th>
                            <th class="postcode-col">Postcode</th>
                            <th class="country-col">Country</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addAddress"
                              >
                                <i class="fa fa-plus" title="Add Address"></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(address, i) in addresses" :key="i">
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="address.AddressTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeAddressType($event, i)"
                              >
                                <option
                                  v-for="item in addressTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="address.AddressTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="address.ShowAddressTypeOther"
                              />
                            </td>
                            <td class="street-col">
                              <textarea
                                v-model="address.Street1"
                                class="form-control"
                                placeholder="Street"
                                maxlength="100"
                              ></textarea>
                            </td>
                            <td class="street-col">
                              <textarea
                                v-model="address.Street2"
                                class="form-control"
                                placeholder="Street"
                                maxlength="100"
                              ></textarea>
                            </td>
                            <td class="city-col">
                              <input
                                type="text"
                                v-model="address.City"
                                class="form-control form-control-sm"
                                placeholder="City"
                                maxlength="50"
                              />
                            </td>
                            <td class="postcode-col">
                              <input
                                type="text"
                                v-model="address.Postcode"
                                class="form-control form-control-sm"
                                placeholder="Postcode"
                                maxlength="20"
                              />
                            </td>
                            <td class="country-col">
                              <select
                                v-model="address.CountryId"
                                class="form-control form-control-sm"
                                required
                              >
                                <option
                                  v-for="item in countries"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeAddress(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Address"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Place of Study as of {{ dateOfUpdate }}</label>
                    <input
                      type="text"
                      v-model="placeOfStudy"
                      class="form-control"
                      placeholder="Input School/Institution Name Here"
                      maxlength="100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Contact Information -->

        <!-- Parent/Guardian Information -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header guardian-header">
                <div><h3>Parent/Guardian Information</h3></div>
                <div>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addGuardian"
                  >
                    <i class="fa fa-plus" title="Add Parent/Guardian"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="row" v-for="(guardian, i) in guardians" :key="i">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header guardian-header">
                        <div>
                          <h4>Parent/Guardian {{ i + 1 }}</h4>
                        </div>
                        <div>
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="removeGuardian(i)"
                          >
                            <i
                              class="fa fa-trash-o"
                              title="Remove Parent/Guardian"
                            ></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="form-row mb-3">
                          <div class="col-md-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="guardian.IsEmergencyContact"
                                :id="'chkEmergencyContact' + i"
                              />
                              <label
                                class="form-check-label"
                                :for="'chkEmergencyContact' + i"
                              >
                                Emergency Contact
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <label>Name</label>
                            <input
                              type="text"
                              v-model="guardian.Name"
                              class="form-control"
                              placeholder="Input Name Here"
                              maxlength="50"
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <label>Relationship</label>
                            <div class="form-row">
                              <div
                                :class="
                                  guardian.ShowRelationshipOthers
                                    ? 'col-5'
                                    : 'col-12'
                                "
                              >
                                <select
                                  class="form-control"
                                  v-model="guardian.RelationshipId"
                                  @change="
                                    onChangeRelationship($event, guardian)
                                  "
                                >
                                  <option value>
                                    -- Please Select Relationship --
                                  </option>
                                  <option
                                    v-for="relationship in relationships"
                                    :value="relationship.Id"
                                    :key="relationship.Id"
                                  >
                                    {{ relationship.Name }}
                                  </option>
                                </select>
                              </div>
                              <div
                                class="col-7"
                                v-if="guardian.ShowRelationshipOthers"
                              >
                                <input
                                  type="text"
                                  v-model="guardian.RelationshipOthers"
                                  class="form-control"
                                  required
                                  maxlength="50"
                                  placeholder="Input Other Relationships Here"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <label>
                              Email<span class="text-danger">*</span>
                            </label>
                            <div class="table-responsive">
                              <table class="table table-bordered email-table">
                                <thead class="thead-light">
                                  <tr>
                                    <th class="no-col">#</th>
                                    <th class="type-col">Type</th>
                                    <th class="email-col">Email</th>
                                    <th class="action-col">
                                      <button
                                        type="button"
                                        class="btn btn-primary"
                                        @click="
                                          addGuardianEmail(guardian.Emails)
                                        "
                                      >
                                        <i
                                          class="fa fa-plus"
                                          title="Add Email"
                                        ></i>
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(email, i) in guardian.Emails"
                                    :key="i"
                                  >
                                    <td class="no-col">{{ i + 1 }}</td>
                                    <td class="type-col">
                                      <select
                                        v-model="email.EmailTypeId"
                                        class="form-control form-control-sm"
                                        required
                                        @change="
                                          onChangeGuardianEmailType(
                                            $event,
                                            i,
                                            guardian.Emails
                                          )
                                        "
                                      >
                                        <option
                                          v-for="emailType in guardianEmailTypes"
                                          :value="emailType.Id"
                                          :key="emailType.Id"
                                        >
                                          {{ emailType.Name }}
                                        </option>
                                      </select>
                                      <input
                                        type="text"
                                        v-model="email.EmailTypeOther"
                                        class="form-control form-control-sm mt-2"
                                        required
                                        maxlength="50"
                                        v-if="email.ShowEmailTypeOther"
                                      />
                                    </td>
                                    <td class="email-col">
                                      <input
                                        type="email"
                                        v-model="email.Email"
                                        class="form-control form-control-sm"
                                        placeholder="Email"
                                        maxlength="100"
                                        required
                                      />
                                    </td>
                                    <td class="action-col">
                                      <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="
                                          removeGuardianEmail(
                                            i,
                                            guardian.Emails
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-trash-o"
                                          title="Remove Email"
                                        ></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="form-group col-md-6">
                            <label>
                              Contact Number<span class="text-danger">*</span>
                            </label>
                            <div class="table-responsive">
                              <table class="table table-bordered contact-table">
                                <thead class="thead-light">
                                  <tr>
                                    <th class="no-col">#</th>
                                    <th class="type-col">Type</th>
                                    <th class="phone-col">Phone</th>
                                    <th class="action-col">
                                      <button
                                        type="button"
                                        class="btn btn-primary"
                                        @click="
                                          addGuardianContactNumber(
                                            guardian.ContactNumbers
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-plus"
                                          title="Add Phone"
                                        ></i>
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(
                                      contactNumber, i
                                    ) in guardian.ContactNumbers"
                                    :key="i"
                                  >
                                    <td class="no-col">{{ i + 1 }}</td>
                                    <td class="type-col">
                                      <select
                                        v-model="
                                          contactNumber.ContactNumberTypeId
                                        "
                                        class="form-control form-control-sm"
                                        required
                                        @change="
                                          onChangeGuardianContactNumberType(
                                            $event,
                                            i,
                                            guardian.ContactNumbers
                                          )
                                        "
                                      >
                                        <option
                                          v-for="item in guardianContactNumberTypes"
                                          :value="item.Id"
                                          :key="item.Id"
                                        >
                                          {{ item.Name }}
                                        </option>
                                      </select>
                                      <input
                                        type="text"
                                        v-model="
                                          contactNumber.ContactNumberTypeOther
                                        "
                                        class="form-control form-control-sm mt-2"
                                        required
                                        maxlength="50"
                                        v-if="
                                          contactNumber.ShowContactNumberTypeOther
                                        "
                                      />
                                    </td>
                                    <td class="phone-col">
                                      <input
                                        type="text"
                                        v-model="contactNumber.Phone"
                                        class="form-control form-control-sm"
                                        placeholder="Phone"
                                        maxlength="20"
                                        required
                                      />
                                    </td>
                                    <td class="action-col">
                                      <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="
                                          removeGuardianContactNumber(
                                            i,
                                            guardian.ContactNumbers
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-trash-o"
                                          title="Remove Phone"
                                        ></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <div class="row">
                              <div class="col-3 fit-content">
                                <label>Address</label>
                              </div>
                              <div class="col-9 fit-content">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="'chkSameAddressAsStudent' + i"
                                    @change="
                                      onChangeCheckSameAddressAsStudent(
                                        $event,
                                        guardian
                                      )
                                    "
                                  />
                                  <label
                                    class="form-check-label"
                                    :for="'chkSameAddressAsStudent' + i"
                                  >
                                    Use same address as student
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="table-responsive">
                              <table class="table table-bordered">
                                <thead class="thead-light">
                                  <tr>
                                    <th class="no-col">#</th>
                                    <th class="type-col">Type</th>
                                    <th class="street-col">Street 1</th>
                                    <th class="street-col">Street 2</th>
                                    <th class="city-col">City</th>
                                    <th class="postcode-col">Postcode</th>
                                    <th class="country-col">Country</th>
                                    <th class="action-col">
                                      <button
                                        type="button"
                                        class="btn btn-primary"
                                        @click="
                                          addGuardianAddress(guardian.Addresses)
                                        "
                                      >
                                        <i
                                          class="fa fa-plus"
                                          title="Add Address"
                                        ></i>
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(address, i) in guardian.Addresses"
                                    :key="i"
                                  >
                                    <td class="no-col">{{ i + 1 }}</td>
                                    <td class="type-col">
                                      <select
                                        v-model="address.AddressTypeId"
                                        class="form-control form-control-sm"
                                        required
                                        @change="
                                          onChangeGuardianAddressType(
                                            $event,
                                            i,
                                            guardian.Addresses
                                          )
                                        "
                                      >
                                        <option
                                          v-for="item in guardianAddressTypes"
                                          :value="item.Id"
                                          :key="item.Id"
                                        >
                                          {{ item.Name }}
                                        </option>
                                      </select>
                                      <input
                                        type="text"
                                        v-model="address.AddressTypeOther"
                                        class="form-control form-control-sm mt-2"
                                        required
                                        maxlength="50"
                                        v-if="address.ShowAddressTypeOther"
                                      />
                                    </td>
                                    <td class="street-col">
                                      <textarea
                                        v-model="address.Street1"
                                        class="form-control"
                                        placeholder="Street"
                                        maxlength="100"
                                      ></textarea>
                                    </td>
                                    <td class="street-col">
                                      <textarea
                                        v-model="address.Street2"
                                        class="form-control"
                                        placeholder="Street"
                                        maxlength="100"
                                      ></textarea>
                                    </td>
                                    <td class="city-col">
                                      <input
                                        type="text"
                                        v-model="address.City"
                                        class="form-control form-control-sm"
                                        placeholder="City"
                                        maxlength="50"
                                      />
                                    </td>
                                    <td class="postcode-col">
                                      <input
                                        type="text"
                                        v-model="address.Postcode"
                                        class="form-control form-control-sm"
                                        placeholder="Postcode"
                                        maxlength="20"
                                      />
                                    </td>
                                    <td class="country-col">
                                      <select
                                        v-model="address.CountryId"
                                        class="form-control form-control-sm"
                                        required
                                      >
                                        <option
                                          v-for="item in countries"
                                          :value="item.Id"
                                          :key="item.Id"
                                        >
                                          {{ item.Name }}
                                        </option>
                                      </select>
                                    </td>
                                    <td class="action-col">
                                      <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="
                                          removeGuardianAddress(
                                            i,
                                            guardian.Addresses
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-trash-o"
                                          title="Remove Address"
                                        ></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Parent/Guardian Information -->

        <!-- Subject Level and Needs -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Subject Level and Needs</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Subject Level as of {{ dateOfUpdate }}</label>
                    <div class="form-row">
                      <div class="col-md-6">
                        <select
                          v-model="subjectLevel.SubjectId"
                          class="form-control"
                          :required="subjectLevel.SubjectLevelId != ''"
                          @change="onChangeSubject($event)"
                        >
                          <option value>-- Please Select Subject --</option>
                          <option
                            v-for="item in subjects"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                        <input
                          type="text"
                          v-model="subjectLevel.SubjectOthers"
                          class="form-control mt-1"
                          required
                          maxlength="100"
                          placeholder="Input Other Subject Here"
                          v-if="subjectLevel.ShowSubjectOthers"
                        />
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0 mt-lg-0">
                        <select
                          v-model="subjectLevel.SubjectLevelId"
                          class="form-control"
                          :required="subjectLevel.SubjectId != ''"
                          @change="onChangeSubjectLevel($event)"
                        >
                          <option value>
                            -- Please Select Subject Level --
                          </option>
                          <option
                            v-for="item in subjectLevels"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                        <input
                          type="text"
                          v-model="subjectLevel.SubjectLevelOthers"
                          class="form-control mt-1"
                          required
                          maxlength="100"
                          placeholder="Input Other Subject Level Here"
                          v-if="subjectLevel.ShowSubjectLevelOthers"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Student's Interest(s)</label>
                    <input
                      type="text"
                      v-model="interest"
                      class="form-control"
                      maxlength="200"
                      placeholder="Input Student's Interest(s) Here"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Preferred Instructor</label>
                    <div class="table-responsive">
                      <table class="table table-bordered instructor-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th>Instructor</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addPreferredInstructor"
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Preferred Instructor"
                                ></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              preferredInstructor, i
                            ) in preferredInstructors"
                            :key="i"
                          >
                            <td class="no-col">{{ i + 1 }}</td>
                            <td>
                              <select
                                v-model="preferredInstructor.InstructorId"
                                class="form-control"
                              >
                                <option value>
                                  -- Please Select Instructor --
                                </option>
                                <option
                                  v-for="item in instructors"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removePreferredInstructor(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Preferred Instructor"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <div class="table-responsive">
                      <table class="table duration-table">
                        <thead class="thead-light">
                          <tr>
                            <th>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="checkAllPreferredDuration"
                                  @change="
                                    onChangeCheckAllPreferredDuration($event)
                                  "
                                />
                                <label class="mt-2 ml-2">
                                  Preferred Class Duration
                                </label>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(duration, i) in durations" :key="i">
                            <td>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="duration.IsSelected"
                                  :id="duration.Id"
                                  @change="onChangeCheckPreferredDuration"
                                />
                                <label :for="duration.Id" class="mt-2 ml-2">
                                  {{ duration.Duration }}
                                </label>
                                <input
                                  type="text"
                                  v-model="duration.DurationOthers"
                                  class="form-control form-control-sm ml-4"
                                  required
                                  maxlength="20"
                                  placeholder="Input Other Class Duration Here"
                                  v-if="
                                    duration.IsSelected &&
                                    duration.Duration == 'Others'
                                  "
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Subject Level and Needs -->

        <!-- Others -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Others</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Status</label>
                    <select v-model="status" class="form-control" required>
                      <option value="Active" selected>Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Remarks</label>
                    <textarea
                      class="form-control"
                      v-model="remarks"
                      maxlength="500"
                      placeholder="Input Remarks Here"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Others -->

        <!-- Button -->
        <div class="text-center" v-if="!isView">
          <router-link
            class="btn btn-danger mr-4"
            :to="{
              name:
                tokenObj.UserType == userTypeMainAdmin
                  ? 'mainAdminStudentList'
                  : 'schoolAdminStudentList',
            }"
          >
            Cancel
          </router-link>
          <button class="btn btn-primary" type="submit">
            {{ $route.params.id ? "Update " : "Add " }}
          </button>
        </div>
        <!-- /Button -->
      </form>
    </fieldset>
    <!-- Button Back -->
    <div class="text-center" v-if="isView">
      <router-link
        v-if="$route.path.includes('/instructor')"
        class="btn btn-primary"
        :to="{ name: 'instructorMyStudents' }"
      >
        <i class="fa fa-reply mr-2"></i>Back to My Students
      </router-link>
      <router-link
        v-else
        class="btn btn-primary"
        :to="{
          name:
            tokenObj.UserType == userTypeMainAdmin
              ? 'mainAdminStudentList'
              : 'schoolAdminStudentList',
        }"
      >
        <i class="fa fa-reply mr-2"></i>Back to Students
      </router-link>
    </div>
    <!-- /Button Back -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Layout from "../../Layout/Layout.vue";
export default {
  components: { Layout },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      defaultCountry: config.DEFAULT_COUNTRY,
      //details
      schoolId: "",
      schools: [],
      userType: "Student",
      registrationDate: "",
      username: "",
      password: "",
      name: "",
      dateOfBirth: "",
      genderId: "",
      genders: [],
      genderCustom: "",
      showGenderCustom: false,
      nationalityId: "",
      nationalities: [],
      citizenshipId: "",
      citizenships: [],
      showCitizenshipOther: false,
      citizenshipOtherNationalityId: "",
      documentNumber: "",
      //contact information
      //--email--
      emails: [
        {
          Id: "",
          EmailTypeId: "",
          EmailTypeOther: "",
          ShowEmailTypeOther: false,
          Email: "",
          SortOrder: "",
        },
      ],
      emailTypes: [],
      //--address--
      addresses: [
        {
          Id: "",
          AddressTypeId: "",
          ShowAddressTypeOther: false,
          AddressTypeOther: "",
          Street1: "",
          Street2: "",
          City: "",
          Postcode: "",
          CountryId: "",
          SortOrder: "",
        },
      ],
      addressTypes: [],
      countries: [],
      //--contact number--
      contactNumbers: [
        {
          Id: "",
          ContactNumberTypeId: "",
          ShowContactNumberTypeOther: false,
          ContactNumberTypeOther: "",
          Phone: "",
        },
      ],
      contactNumberTypes: [],
      placeOfStudy: "",
      updatedDate: "",

      //parent/guardian information
      guardians: [
        {
          IsEmergencyContact: false,
          Name: "",
          RelationshipId: "",
          ShowRelationshipOthers: false,
          RelationshipOthers: "",
          Emails: [
            {
              Id: "",
              EmailTypeId: "",
              EmailTypeOther: "",
              ShowEmailTypeOther: false,
              Email: "",
              SortOrder: "",
            },
          ],
          ContactNumbers: [
            {
              Id: "",
              ContactNumberTypeId: "",
              ShowContactNumberTypeOther: false,
              ContactNumberTypeOther: "",
              Phone: "",
            },
          ],
          Addresses: [
            {
              Id: "",
              AddressTypeId: "",
              ShowAddressTypeOther: false,
              AddressTypeOther: "",
              Street1: "",
              Street2: "",
              City: "",
              Postcode: "",
              CountryId: "",
              SortOrder: "",
            },
          ],
        },
      ],
      guardianEmailTypes: [],
      guardianContactNumberTypes: [],
      guardianAddressTypes: [],
      relationships: [],

      //subject level and needs
      subjectLevel: {
        SubjectId: "",
        ShowSubjectOthers: false,
        SubjectOthers: "",
        SubjectLevelId: "",
        ShowSubjectLevelOthers: false,
        SubjectLevelOthers: "",
      },
      subjects: [],
      subjectLevels: [],
      //--interest
      interest: "",
      //--preferred class duration
      durations: [],
      checkAllPreferredDuration: false,
      //-preferred instructor
      instructors: [],
      preferredInstructors: [
        {
          Id: "",
          InstructorId: "",
        },
      ],
      //others
      status: "Active",
      remarks: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isView() {
      return this.$route.path.includes("/show");
    },
    dateOfUpdate() {
      let updatedDate = this.updatedDate;
      if (!this.updatedDate) {
        let today = new Date();
        let date = today.getDate();
        let months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        let month = months[today.getMonth()];
        let year = today.getFullYear();
        updatedDate = `${date} ${month} ${year}`;
      }
      return updatedDate;
    },
  },
  watch: {
    schoolId(val) {
      if (val) {
        this.getSubjectsForStudent();
        this.getSubjectLevelsForStudent();
      }
    },
    "subjectLevel.SubjectId": function (val, oldVal) {
      let newSubject = this.subjects.find((c) => c.Id == val);
      let oldSubject = this.subjects.find((c) => c.Id == oldVal);
      if (
        oldSubject &&
        oldSubject.Name == "None" &&
        newSubject &&
        newSubject.Name != "None"
      ) {
        this.subjectLevel.SubjectLevelId = "";
      }
    },
  },
  methods: {
    //for details section
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getGenders() {
      API.common
        .getGenders({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.genders = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeGender(event) {
      let genderId = event.target.value;
      let gender = this.genders.find((c) => c.Id == genderId);
      this.showGenderCustom = gender && gender.Name == "Custom";
    },
    getNationalities() {
      API.common
        .getNationalities({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.nationalities = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getCitizenships() {
      API.common
        .getCitizenships({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.citizenships = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCitizenship(event) {
      let citizenshipId = event.target.value;
      let citizenship = this.citizenships.find((c) => c.Id == citizenshipId);
      this.showCitizenshipOther = citizenship && citizenship.Name == "Other";
    },
    //for contact information section
    //email
    getEmailTypesForStudent() {
      API.student
        .getEmailTypesForStudent({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.emailTypes = response.data.data;
            if (!this.$route.params.id)
              this.emails[0].EmailTypeId = this.emailTypes[0].Id;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeEmailType(event, index) {
      let emailTypeId = event.target.value;
      let emailType = this.emailTypes.find((c) => c.Id == emailTypeId);
      this.emails[index].ShowEmailTypeOther =
        emailType && emailType.Name == "Other";
    },
    removeEmail(index) {
      this.emails.splice(index, 1);
    },
    addEmail() {
      this.emails.push({
        Id: "",
        EmailTypeId: this.emailTypes[0].Id,
        EmailTypeOther: "",
        ShowEmailTypeOther: false,
        Email: "",
        SortOrder: "",
      });
    },
    //address
    getAddressTypesForStudent() {
      API.student
        .getAddressTypesForStudent({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.addressTypes = response.data.data;
            if (!this.$route.params.id)
              this.addresses[0].AddressTypeId = this.addressTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getCountries() {
      API.common
        .getCountries({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            if (!this.$route.params.id) {
              let countryId = this.countries.find(
                (c) => c.Name == this.defaultCountry
              ).Id;
              this.addresses[0].CountryId = countryId;
              this.guardians[0].Addresses[0].CountryId = countryId;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeAddressType(event, index) {
      let addressTypeId = event.target.value;
      let addressType = this.addressTypes.find((c) => c.Id == addressTypeId);
      this.addresses[index].ShowAddressTypeOther =
        addressType && addressType.Name == "Other";
    },
    removeAddress(index) {
      this.addresses.splice(index, 1);
    },
    addAddress() {
      this.addresses.push({
        Id: "",
        AddressTypeId: this.addressTypes[0].Id,
        ShowAddressTypeOther: false,
        AddressTypeOther: "",
        Street1: "",
        Street2: "",
        City: "",
        Postcode: "",
        CountryId: this.countries.find((c) => c.Name == this.defaultCountry).Id,
        SortOrder: "",
      });
    },
    //contact number
    getContactNumberTypesForStudent() {
      API.student
        .getContactNumberTypesForStudent({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.contactNumberTypes = response.data.data;
            if (!this.$route.params.id)
              this.contactNumbers[0].ContactNumberTypeId =
                this.contactNumberTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeContactNumberType(event, index) {
      let contactNumberTypeId = event.target.value;
      let contactNumberType = this.contactNumberTypes.find(
        (c) => c.Id == contactNumberTypeId
      );
      this.contactNumbers[index].ShowContactNumberTypeOther =
        contactNumberType && contactNumberType.Name == "Other";
    },
    removeContactNumber(index) {
      this.contactNumbers.splice(index, 1);
    },
    addContactNumber() {
      this.contactNumbers.push({
        Id: "",
        ContactNumberTypeId: this.contactNumberTypes[0].Id,
        ContactNumberTypeOther: "",
        ShowContactNumberTypeOther: false,
        Phone: "",
      });
    },

    //for parent/guardian information
    getRelationships() {
      API.common
        .getRelationships({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.relationships = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeRelationship(event, guardian) {
      let relationshipId = event.target.value;
      let relationship = this.relationships.find((c) => c.Id == relationshipId);
      guardian.ShowRelationshipOthers =
        relationship && relationship.Name == "Others";
    },
    //--guardian emails
    getGuardianEmailTypes() {
      API.instructor
        .getEmailTypesForInstructor({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.guardianEmailTypes = response.data.data;
            if (!this.$route.params.id)
              this.guardians[0].Emails[0].EmailTypeId =
                this.guardianEmailTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeGuardianEmailType(event, index, guardianEmails) {
      let emailTypeId = event.target.value;
      let emailType = this.guardianEmailTypes.find((c) => c.Id == emailTypeId);
      guardianEmails[index].ShowEmailTypeOther =
        emailType && emailType.Name == "Other";
    },
    removeGuardianEmail(index, guardianEmails) {
      guardianEmails.splice(index, 1);
    },
    addGuardianEmail(guardianEmails) {
      guardianEmails.push({
        Id: "",
        EmailTypeId: this.guardianEmailTypes[0].Id,
        EmailTypeOther: "",
        ShowEmailTypeOther: false,
        Email: "",
        SortOrder: "",
      });
    },
    //--guardian contact number
    getGuardianContactNumberTypes() {
      API.instructor
        .getContactNumberTypesForInstructor({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.guardianContactNumberTypes = response.data.data;
            if (!this.$route.params.id)
              this.guardians[0].ContactNumbers[0].ContactNumberTypeId =
                this.guardianContactNumberTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeGuardianContactNumberType(event, index, guardianContactNumbers) {
      let contactNumberTypeId = event.target.value;
      let contactNumberType = this.guardianContactNumberTypes.find(
        (c) => c.Id == contactNumberTypeId
      );
      guardianContactNumbers[index].ShowContactNumberTypeOther =
        contactNumberType && contactNumberType.Name == "Other";
    },
    removeGuardianContactNumber(index, guardianContactNumbers) {
      guardianContactNumbers.splice(index, 1);
    },
    addGuardianContactNumber(guardianContactNumbers) {
      guardianContactNumbers.push({
        Id: "",
        ContactNumberTypeId: this.guardianContactNumberTypes[0].Id,
        ShowContactNumberTypeOther: false,
        ContactNumberTypeOther: "",
        Phone: "",
      });
    },
    //--guardian address
    getGuardianAddressTypes() {
      API.instructor
        .getAddressTypesForInstructor({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.guardianAddressTypes = response.data.data;
            if (!this.$route.params.id)
              this.guardians[0].Addresses[0].AddressTypeId =
                this.guardianAddressTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeGuardianAddressType(event, index, guardianAddresses) {
      let addressTypeId = event.target.value;
      let addressType = this.guardianAddressTypes.find(
        (c) => c.Id == addressTypeId
      );
      guardianAddresses[index].ShowAddressTypeOther =
        addressType && addressType.Name == "Other";
    },
    removeGuardianAddress(index, guardianAddresses) {
      guardianAddresses.splice(index, 1);
    },
    addGuardianAddress(guardianAddresses) {
      guardianAddresses.push({
        Id: "",
        AddressTypeId: this.guardianAddressTypes[0].Id,
        ShowAddressTypeOther: false,
        AddressTypeOther: "",
        Street1: "",
        Street2: "",
        City: "",
        Postcode: "",
        CountryId: this.countries.find((c) => c.Name == this.defaultCountry).Id,
        SortOrder: "",
      });
    },
    onChangeCheckSameAddressAsStudent(event, guardian) {
      if (event.target.checked) {
        guardian.Addresses = JSON.parse(JSON.stringify(this.addresses));
      } else {
        guardian.Addresses = [
          {
            Id: "",
            AddressTypeId: this.guardianAddressTypes[0].Id,
            ShowAddressTypeOther: false,
            AddressTypeOther: "",
            Street1: "",
            Street2: "",
            City: "",
            Postcode: "",
            CountryId: this.countries.find((c) => c.Name == this.defaultCountry)
              .Id,
            SortOrder: "",
          },
        ];
      }
    },
    //--main guardian function
    removeGuardian(index) {
      this.guardians.splice(index, 1);
    },
    addGuardian() {
      this.guardians.push({
        IsEmergencyContact: false,
        Name: "",
        RelationshipId: "",
        ShowRelationshipOthers: false,
        RelationshipOthers: "",
        Emails: [
          {
            Id: "",
            EmailTypeId: this.guardianEmailTypes[0].Id,
            EmailTypeOther: "",
            ShowEmailTypeOther: false,
            Email: "",
            SortOrder: "",
          },
        ],
        ContactNumbers: [
          {
            Id: "",
            ContactNumberTypeId: this.guardianContactNumberTypes[0].Id,
            ShowContactNumberTypeOther: false,
            ContactNumberTypeOther: "",
            Phone: "",
          },
        ],
        Addresses: [
          {
            Id: "",
            AddressTypeId: this.guardianAddressTypes[0].Id,
            ShowAddressTypeOther: false,
            AddressTypeOther: "",
            Street1: "",
            Street2: "",
            City: "",
            Postcode: "",
            CountryId: this.countries.find((c) => c.Name == this.defaultCountry)
              .Id,
            SortOrder: "",
          },
        ],
      });
    },

    //for subject level and needs
    getSubjectsForStudent() {
      API.subject
        .getSubjectsForStudent({
          Token: this.tokenObj.Token,
          SchoolId:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? this.schoolId
              : this.tokenObj.SchoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjectLevelsForStudent() {
      API.student
        .getSubjectLevelsForStudent({
          Token: this.tokenObj.Token,
          SchoolId:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? this.schoolId
              : this.tokenObj.SchoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjectLevels = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSubject(event) {
      let subjectId = event.target.value;
      let subject = this.subjects.find((c) => c.Id == subjectId);
      this.subjectLevel.ShowSubjectOthers = subject && subject.Name == "Others";
      if (subject && subject.Name == "None") {
        this.subjectLevel.ShowSubjectLevelOthers = false;
        let subjectLevel = this.subjectLevels.find((c) => c.Name == "None");
        this.subjectLevel.SubjectLevelId = subjectLevel.Id;
      }
    },
    onChangeSubjectLevel(event) {
      let subjectLevelId = event.target.value;
      let subjectLevel = this.subjectLevels.find((c) => c.Id == subjectLevelId);
      this.subjectLevel.ShowSubjectLevelOthers =
        subjectLevel && subjectLevel.Name == "Others";
      if (subjectLevel && subjectLevel.Name == "None") {
        this.subjectLevel.ShowSubjectOthers = false;
        let subject = this.subjects.find((c) => c.Name == "None");
        this.subjectLevel.SubjectId = subject.Id;
      }
    },
    //preferred class duration
    getClassDurations() {
      API.class
        .getClassDurations({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.durations = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCheckAllPreferredDuration(event) {
      this.checkAllPreferredDuration = event.target.checked;
      for (let duration of this.durations) {
        duration.IsSelected = this.checkAllPreferredDuration;
      }
    },
    onChangeCheckPreferredDuration() {
      let selectedDurations = this.durations.filter(
        (c) => c.IsSelected == true
      );
      this.checkAllPreferredDuration =
        selectedDurations.length == this.durations.length;
    },
    //preferred instructor
    onChangeSchool() {
      this.preferredInstructors = [
        {
          Id: "",
          InstructorId: "",
        },
      ];
      this.getSchoolInstructors(this.schoolId);
    },
    getSchoolInstructors(schoolId) {
      API.school
        .getSchoolInstructors({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.instructors = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    removePreferredInstructor(index) {
      this.preferredInstructors.splice(index, 1);
    },
    addPreferredInstructor() {
      this.preferredInstructors.push({
        Id: "",
        InstructorId: "",
      });
    },
    //main function
    saveStudent() {
      if (this.emails.length == 0) {
        this.$swal("Please add at least 1 email", { icon: "error" });
        return;
      }
      if (this.contactNumbers.length == 0) {
        this.$swal("Please add at least 1 contact number", { icon: "error" });
        return;
      }
      for (let i = 0; i < this.guardians.length; i++) {
        if (this.guardians[i].Emails.length == 0) {
          this.$swal(
            "Please add at least 1 email for Parent/Guardian " + (i + 1),
            { icon: "error" }
          );
          return;
        }
        if (this.guardians[i].ContactNumbers.length == 0) {
          this.$swal(
            "Please add at least 1 contact number for Parent/Guardian " +
              (i + 1),
            { icon: "error" }
          );
          return;
        }
      }

      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        UserType: this.userType,
        RegistrationDateInput: this.registrationDate,
        UserName: this.username,
        Password: this.password,
        Name: this.name,
        DateOfBirthInput: this.dateOfBirth,
        GenderId: this.genderId,
        GenderCustom: this.genderCustom,
        NationalityId: this.nationalityId,
        CitizenshipId: this.citizenshipId,
        CitizenshipOtherNationalityId: this.citizenshipOtherNationalityId,
        DocumentNumber: this.documentNumber,
        Emails: this.emails,
        Addresses: this.addresses,
        ContactNumbers: this.contactNumbers,
        PlaceOfStudy: this.placeOfStudy,
        Guardians: this.guardians,
        SubjectLevel: this.subjectLevel,
        Interest: this.interest,
        PreferredClassDurations: this.durations.filter(
          (c) => c.IsSelected == true
        ),
        PreferredInstructors: this.preferredInstructors,
        Status: this.status,
        Remarks: this.remarks,
      };
      let action = this.$route.params.id ? "update" : "add";
      let text = `Are you sure you want to ${action} the student?`;
      this.$swal({
        title: "Are you sure?",
        text: text,
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.student
            .saveStudent(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success)
                this.$router.replace({
                  name:
                    this.tokenObj.UserType == this.userTypeMainAdmin
                      ? "mainAdminStudentList"
                      : "schoolAdminStudentList",
                });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getStudentDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.student
        .getStudentDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let student = response.data.data;
            this.updatedDate = student.ModifiedDateDisplay;
            this.schoolId = student.SchoolId;
            this.getSchoolInstructors(student.SchoolId);
            this.userType = student.UserType;
            this.registrationDate = student.RegistrationDateCal;
            this.username = student.UserName;
            this.password = student.Password;
            this.name = student.Name;
            this.dateOfBirth = student.DateOfBirthCal;
            this.genderId = student.GenderId ? student.GenderId : this.genderId;
            this.genderCustom = student.GenderCustom;
            this.showGenderCustom = student.ShowGenderCustom;
            this.nationalityId = student.NationalityId
              ? student.NationalityId
              : this.nationalityId;
            this.citizenshipId = student.CitizenshipId
              ? student.CitizenshipId
              : this.citizenshipId;
            this.showCitizenshipOther = student.ShowCitizenshipOther;
            this.citizenshipOtherNationalityId =
              student.CitizenshipOtherNationalityId
                ? student.CitizenshipOtherNationalityId
                : this.citizenshipOtherNationalityId;
            this.documentNumber = student.DocumentNumber;
            this.placeOfStudy = student.PlaceOfStudy;
            this.emails = student.Emails.length ? student.Emails : this.emails;
            this.addresses = student.Addresses;
            this.contactNumbers = student.ContactNumbers;
            this.guardians = student.Guardians;
            this.subjectLevel = student.SubjectLevel
              ? student.SubjectLevel
              : this.subjectLevel;
            this.interest = student.Interest;
            this.durations = student.PreferredClassDurations;
            this.checkAllPreferredDuration =
              student.PreferredClassDurations.length ==
              student.PreferredClassDurations.filter(
                (c) => c.IsSelected == true
              ).length;
            this.preferredInstructors = student.PreferredInstructors;
            this.status = student.Status;
            this.remarks = student.Remarks;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    //details
    this.getSchools();
    this.getGenders();
    this.getNationalities();
    this.getCitizenships();
    //contact information
    this.getEmailTypesForStudent();
    this.getAddressTypesForStudent();
    this.getCountries();
    this.getContactNumberTypesForStudent();
    //guardian information
    this.getRelationships();
    this.getGuardianEmailTypes();
    this.getGuardianContactNumberTypes();
    this.getGuardianAddressTypes();
    //subject level and needs
    if (!this.$route.params.id) {
      this.getClassDurations();
      if (this.tokenObj.UserType != this.userTypeMainAdmin) {
        this.getSchoolInstructors(this.tokenObj.SchoolId);
        this.getSubjectsForStudent();
        this.getSubjectLevelsForStudent();
      }
    }
    if (this.$route.params.id) this.getStudentDetail();
  },
};
</script>

<style scoped>
.id-div {
  padding-top: 9px;
}
.no-col {
  width: 40px;
  vertical-align: middle;
}
.type-col {
  width: 150px;
}
.action-col {
  width: 64px;
}
.postcode-col {
  width: 110px;
}
.table-responsive,
.table {
  margin-bottom: 0;
}
.guardian-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.guardian-header div {
  margin-left: auto;
}
.guardian-header h3,
.guardian-header h4 {
  margin: 0;
}
.form-check-label {
  margin-top: 2px;
}
.duration-table {
  margin-top: 27px;
}
.duration-table td {
  padding-top: 0;
  padding-bottom: 0;
  border-top: none;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}
.duration-table tr:last-child td {
  border-bottom: 1px solid #dee2e6;
}

@media screen and (max-width: 767.98px) {
  .id-div {
    padding-top: 0px;
  }
  .email-table,
  .contact-table {
    width: 570px !important;
  }
  .instructor-table,
  .duration-table {
    width: 367px !important;
  }
  .duration-table {
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/StudentEdit.vue